export default __webpack_public_path__ + "static/media/circuitron.64e397cb.png";